import {
    BaseReport,
    darkBarChartColor,
    darkerOrangeColor,
    generalTitleColor,
    lightRedColor,
    PAGE_MARGIN,
    veryLightOrangeColor,
} from './BaseReport';
// lodash
import {chunk, uniqBy} from 'lodash';
import truncateString from '../commons/truncateString';
// interfaces
import {IUsers} from '../interfaces/commons/IUsers';
import {ISchool} from '../interfaces/commons/ISchool';

/* tslint:disable:curly */

class SchoolCoverageReport extends BaseReport {

  constructor(user: IUsers, school: ISchool, dataToReport: any, logoURL: string) {
    super(user, school, dataToReport, logoURL);
  }

  public async downloadReport(): Promise<any> {
    try {
      

      const reportAnualCoverage = {
        content: this.dataToReport.data.categories.flatMap(
          (category: any, index: number) =>
            this.buildCoverageBySchoolReport(category, index, this.dataToReport.data.categories.length),
        ),
      };

      return await this.generateReport(reportAnualCoverage, {
        reportTitle: 'COBERTURA CURRICULAR POR INSTITUCIÓN',
        firstTitle: this.dataToReport.education,
        reportType: this.dataToReport.reportType,
        emissionDate: this.dataToReport.emissionDate,
        pageOrientation: 'landScape',
      });
    } catch (error) {
      console.error('ERROR EN REPORTE DE COBERTURA POR CURSOS', error);
    }
  }

  public buildCoverageBySchoolReport(category: any, index: number, categoriesCount: number): any[] {
    const changeHeaderAndFooter: string = JSON.stringify({
      header: category.cName,
    });

    const groupedSubjects: any[] = [];
    let subjects: any[] = [];
    for (let i = 0; i < category.subjects.length; i++) {
      subjects.push(category.subjects[i]);
      let totalUnits: any[] = subjects.flatMap((subjectIterated) => subjectIterated.units.concat('TOTAL'));
      if (totalUnits.length === 15) {
        groupedSubjects.push({
          subjects,
          groupedUnits: totalUnits,
        });
        subjects = [];
      } else if (totalUnits.length > 15) {
        subjects.pop();
        totalUnits = subjects.flatMap((subjectIterated) => subjectIterated.units.concat('TOTAL'));
        groupedSubjects.push({
          subjects,
          groupedUnits: totalUnits,
        });
        subjects = [];
        i--;
      } else if (i === category.subjects.length - 1) {
        groupedSubjects.push({
          subjects,
          groupedUnits: totalUnits,
        });
      }
    }
    return [
      this.generalTable({
        tableContent: {
          widths: ['*'],
          heights: ['auto', this.documentHeight / 5],
          body: [
            [
              this.generalTableHeader({
                headerContent: {
                  text: 'COBERTURA CURRICULAR POR ESTABLECIMIENTO',
                },
                style: ['reportPartTitle'],
              }),
            ],
            [
              {
                margin: [0, 0, 0, 0],
                alignment: 'center',
                image: BaseReport.buildChart(
                  this.documentHeight / 5,
                  this.documentWidth - (4 * PAGE_MARGIN),
                  {
                    xAxis: {
                      type: 'category',
                      axisTick: {
                        alignWithLabel: 'center',
                      },
                      axisLabel: {
                        fontSize: 8,
                      },
                      data: category.institutions.map((institution: any ) => institution.institution),
                    },
                    grid: {
                      top: 15,
                      bottom: 15,
                      left: 'center',
                      width: '90%',
                      containLabel: true,
                    },
                    yAxis: { show: false },
                    series: [
                      {
                        type: 'bar',
                        data: category.institutions
                          .map((institution: any) => institution.totalDoneCurricularPercentageByInstitution),
                        barWidth: 25,
                        label: {
                          show: true,
                          position: 'top',
                          verticalAlign: 'middle',
                          align: 'center',
                          formatter: '{c}%',
                          color: 'black',
                          fontSize: 8,
                        },
                      },
                    ],
                    itemStyle: {
                      color: darkBarChartColor,
                    },
                  },
                ),
              },
            ],
          ],
        },
      }),
      ...groupedSubjects.map((gs) => {
        return this.generalTable({
          tableContent: {
            widths: [50].concat(
              gs.subjects.flatMap((subject: any) => subject.units.map(() => '*').concat(['*'])),
              [50],
            ),
            keepWithHeaderRows: 2,
            headerRows: 2,
            body: [
              [
                {
                  rowSpan: 2,
                  text: '',
                  border: [false, false, true, true],
                },
                ...gs.subjects.flatMap((subject: any) => ([{
                  text: truncateString(15, subject.subject),
                  colSpan: subject.units.length + 1,
                  alignment: 'center',
                  border: [true, false, true, false],
                  borderColor: ['white', null, 'white', null],
                }].concat(Array(subject.units.length).fill('')))),
                {
                  rowSpan: 2,
                  margin: [0, 7, 0, 0],
                  text: 'TOTAL',
                  alignment: 'center',
                  border: [true, false, false, true],
                  borderColor: ['white', null, null, darkerOrangeColor],
                },
              ],
              [
                '',
                ...gs.subjects.flatMap((subject: any) => subject.units.map((unit: any) => ({
                  text: unit.unit,
                  alignment: 'center',
                  border: [true, true, true, true],
                  borderColor: ['white', 'white', 'white', darkerOrangeColor],
                })).concat([{
                  text: 'TOTAL', alignment: 'center',
                  border: [true, true, true, true],
                  borderColor: ['white', 'white', 'white', darkerOrangeColor],
                }])),
                '',
              ],
              ...uniqBy(gs.subjects.flatMap((subject: any) => subject.institutions.map((institution: any) => {
                return {
                  row: [
                    { text: institution.institution, alignment: 'center' },
                    ...gs.groupedUnits.map((unit: any) => {
                        if (unit === 'TOTAL') return {
                          text: `${institution.totalPercentageByInstitutionAndCourse}%`, alignment: 'center' };

                        const institutionUnit = institution.units
                          .find((institutionUnitIterated: any) => institutionUnitIterated.unit === unit.unit);
                        if (!institutionUnit) return '';
                        return { text: `${institutionUnit.doneUnitPercentage}%`, alignment: 'center' };
                    }).concat({ text: `${institution.totalDonePercentageByInstitution}%`, alignment: 'center' }),
                  ],
                  institutionId: institution.institutionId,
                };
              })), 'institutionId').map((e: any) => e.row),
            ],
          },
          layout: {
            fillColor: (rowIndex: number, node: any, columnIndex: number): any => {
              if (rowIndex <= 1) {
                if (rowIndex === 0) return lightRedColor;
                if (rowIndex === 1) {
                  if (columnIndex === 0 || columnIndex === node.table.widths.length - 1) return lightRedColor;
                  else return veryLightOrangeColor;
                }
              } else return '';
            },
            hLineWidth: (i: number): number => {
              if (i === 2) return 3;
              else if (i > 0) return 2;
              else return 0;
            },
            vLineWidth: (): number => 2,
            hLineColor: (i: number): any => {
              if (i === 2) return darkerOrangeColor;
              else if (i > 2) return generalTitleColor;
            },
          },
        });
      }),
      {
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: 0,
            x2: this.documentHeight - (2 * PAGE_MARGIN),
            y2: 0,
            lineWidth: 1,
            lineColor: 'grey',
          },
        ],
        margin: [0, 0, 0, 10],
      },
      { text: 'INSTITUCIONES', alignment: 'left', fontSize: 9, margin: [0, 0, 0, 5] },
      {
        fontSize: 8,
        columns: chunk(category.institutions, 5).flatMap((schools: any[]) => ({
          stack: schools.map((school: any) => `${school.institution}: ${school.iName}`),
        })),
        // text: `${institution.abreviatura}: ${institution.nombre}`,
        // width: 'auto',
      },
      {
        text: '0',
        color: 'white',
        fontSize: 1,
        changeHeaderAndFooter,
        margin: 0,
      },
      (index === categoriesCount - 1) ? '' : BaseReport.pageBreak('after'),
    ];
  }
}

export {
  SchoolCoverageReport,
};
